import { apiClient, unwrap } from '@/lib/apiClient';
import type { ApiSuccess } from '@/types/api';
import type { LeaveRequestStatus, TeacherLeaveRequest } from '../types/leaveRequests';

/**
 * The leave a class teacher's own sections are waiting on.
 *
 * `/institute/*` rather than a teacher area of its own: this is the other half
 * of the register, gated by the same permissions and the same ownership rule —
 * the caller must hold the section, which the server checks against their
 * allocations rather than trusting anything in the request (CLAUDE.md §10).
 */
export const leaveRequestsApi = {
  /**
   * With no section named it is every section the caller is class teacher of,
   * which is what "what needs answering?" means to somebody who holds two.
   */
  list: (params?: { classSectionUuid?: string; status?: LeaveRequestStatus }) =>
    unwrap(
      apiClient.get<ApiSuccess<TeacherLeaveRequest[]>>('/institute/leave-requests', { params }),
    ),

  /** Approving or declining one. Only a pending request can be answered. */
  decide: (uuid: string, payload: { status: 'APPROVED' | 'REJECTED'; note?: string }) =>
    unwrap(
      apiClient.patch<ApiSuccess<TeacherLeaveRequest>>(
        `/institute/leave-requests/${uuid}`,
        payload,
      ),
    ),
};
